import authReducer from './firebaseSlice';
import toastReducer from './toast';

const reducer = {
    auth: authReducer,
    toast: toastReducer,
};

export default reducer;
